import * as React from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import HttpActionsService from '../../../Services/HttpActionsService'
import UserStore from '../../../Stores/UserStore'
import { history } from '../../../Routing'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { getCatalogProductForm } from '../../../Model/CatalogProduct'

export interface ICatalogProductPageProps {
    httpActionsService: HttpActionsService
    userStore?: UserStore
    localizationStore: LocalizationStore
}

@inject('httpActionsService')
@inject('userStore')
@inject('localizationStore')
@observer
class CatalogProductPage extends React.Component<ICatalogProductPageProps> {
    constructor(props: any) {
        super(props)

        if (!UserStore.getInstance().checkSession) {
            history.push('/login')
        }
        this.props.httpActionsService!.getCatalogProduct(this.props['match']!['params']['id'])
    }

    render() {
        const { localizationStore } = this.props
        return (
            <div className="catalogProductPage row">
                <div className="col-12">
                    <h4>{localizationStore!.t('CatalogProductPageHeader')}</h4>
                </div>
                <div className="col-12">
                    {getCatalogProductForm()}
                </div>
            </div>
        )
    }
}

export default withRouter(CatalogProductPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/CatalogProduct/CatalogProductPage.tsx